import React from "react";
import { MainLayout } from "../components/MainLayout";
import { useApp } from "../components/AppContext";
import { useTranslation } from "../i18n/TranslationContext";

export function CodeOfConductIntro() {
	const { navigateDirectly } = useApp();
	const { t } = useTranslation();

	const handleContinue = () => {
		navigateDirectly("app-code-of-conduct");
	};

	return (
		<MainLayout showBottomNav={false}>
			<div className="intro-screen-container">
				<div className="intro-header">
					<div className="intro-icon">
						<span className="text-4xl">📜</span>
					</div>
					<h2 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
						{t("codeOfConductIntro.title")}
					</h2>
				</div>

				<div className="intro-content">
					<h3 className="text-xl font-semibold text-[var(--ucm-text-dark)] mb-6">
						{t("codeOfConductIntro.whyImportant")}
					</h3>

					<div className="intro-reasons">
						<div className="reason-item">
							<div className="reason-icon">
								<span className="text-white text-sm">🛡️</span>
							</div>
							<div className="reason-text">
								<strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
									{t("codeOfConductIntro.safetyFirst")}
								</strong>
								<p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
									{t("codeOfConductIntro.safetyFirstDesc")}
								</p>
							</div>
						</div>

						<div className="reason-item">
							<div className="reason-icon">
								<span className="text-white text-sm">🤝</span>
							</div>
							<div className="reason-text">
								<strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
									{t("codeOfConductIntro.professionalStandards")}
								</strong>
								<p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
									{t("codeOfConductIntro.professionalStandardsDesc")}
								</p>
							</div>
						</div>

						<div className="reason-item">
							<div className="reason-icon">
								<span className="text-white text-sm">🔒</span>
							</div>
							<div className="reason-text">
								<strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
									{t("codeOfConductIntro.confidentiality")}
								</strong>
								<p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
									{t("codeOfConductIntro.confidentialityDesc")}
								</p>
							</div>
						</div>
					</div>

					<div className="trust-message">
						<p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed m-0">
							<strong>{t("codeOfConductIntro.clearExpectations")}</strong>{" "}
							{t("codeOfConductIntro.clearExpectationsDesc")}
						</p>
					</div>
				</div>

				<div className="intro-actions">
					<button
						onClick={handleContinue}
						className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200"
					>
						{t("codeOfConductIntro.reviewCodeOfConduct")}
					</button>
				</div>
			</div>
		</MainLayout>
	);
}
